import React from 'react';

const KOALENDAR = 'https://koalendar.com/e/meet-with-mark-bernstein';

// The three-step deal journey shown in the dark card. Steps 1–2 are the Diligentsia + Morsebridge
// partnership; step 3 is the firm running it themselves — hence the distinct marker colours.
const STEPS = [
    { n: '1', tone: 'blue', title: 'Qualified dealflow', body: 'Pre-diligenced opportunities matched to your thesis' },
    { n: '2', tone: 'pink', title: 'Transaction prep & diligence', body: 'Target companies made investment-ready, fast' },
    { n: '3', tone: 'green', title: 'Platform & monitoring', body: "Your firm's deal stack, running in-house" },
];

const PEHeroSection = () => (
    <section className="lp-pe-hero">
        <div className="lp-pe-hero-inner">
            <div>
                <span className="lp-pe-eyebrow" data-lp-reveal><span className="dot" />For Private Equity</span>
                <h1 className="lp-pe-h1" data-lp-reveal data-lp-delay="60">Increase portfolio value.<br />Simply.</h1>
                <p className="lp-pe-lede" data-lp-reveal data-lp-delay="120">Structured research and deal identification process. Qualify leads faster, cut initial diligence cost, and grow portfolio company value.</p>
                <a className="lp-pe-btn lp-pe-btn--primary" href={KOALENDAR} target="_blank" rel="noopener noreferrer" data-lp-reveal data-lp-delay="180">Book a call</a>
            </div>

            <div className="lp-pe-journey" data-lp-reveal data-lp-delay="140">
                <div className="lp-pe-journey-glow" aria-hidden="true" />
                <div className="lp-pe-journey-label">The PE deal journey</div>
                <div className="lp-pe-journey-steps">
                    {STEPS.map((s, i) => (
                        <React.Fragment key={s.n}>
                            <div className="lp-pe-journey-step">
                                <div className={`lp-pe-journey-num is-${s.tone}`}>{s.n}</div>
                                <div>
                                    <div className="t">{s.title}</div>
                                    <div className="d">{s.body}</div>
                                </div>
                            </div>
                            {i < STEPS.length - 1 && <div className="lp-pe-journey-rule" />}
                        </React.Fragment>
                    ))}
                </div>
                <div className="lp-pe-journey-foot">
                    <span>Steps 1 &amp; 2 delivered by Diligentsia</span>
                    <span className="mb">+ Morsebridge</span>
                </div>
            </div>
        </div>
    </section>
);

export default PEHeroSection;
